import { Routes } from '@angular/router';
import { AdminUserRouteGuardService } from 'projects/shared/src/lib/guards/admin-user-route-guard.service';
// import { DocumentComponent } from './manage-documents/document/document.component';
// import { EditDocumentComponent } from './manage-documents/document/edit-document/edit-document.component';
import { ProjectListComponent } from './project-list/project-list.component';

export const UserRoutes: Routes = [
    {
        path: 'projects',
        children: [
            {
                path: "all-projects",
                component: ProjectListComponent,
                //canActivate: [AdminUserRouteGuardService]
            },
            {
                // path: 'all-projects/:id/documents', component: DocumentComponent,
                // children: [
                //     {
                //         path: ':id/edit-document', component: EditDocumentComponent
                //     }
                // ]
            }
        ]
    }
]